import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import swal from 'sweetalert2';
import { CommonService } from '../../../services/index';
import { AddDsrFileComponent } from './addDsrFile.component';

@Component({
    selector: 'dsr-input-files-tab',
    templateUrl: './dsrInputFiles.component.html',
})
export class DsrInputFilesComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    @ViewChild('fileInput') fileInput: ElementRef;

    isLoading: boolean = false;
    fileGroups: any[] = [];
    selectedFile: any = null;
    selectedFolder: string = '';
    selectedGroup: any = null;
    filterExpand: boolean = false;

    bsModalRef: BsModalRef;

    constructor(private commonService: CommonService, private modalService: BsModalService) { }

    ngOnInit(): void {
        this.loadFiles();
    }

    loadFiles(): void {
        this.isLoading = true;
        let that = this;
        this.commonService.getDsrInputFiles()
            .then(function(res: any) {
                that.isLoading = false;
                if (res && res.success) {
                    that.fileGroups = res.groups || [];
                    if (that.fileGroups.length > 0) {
                        that.selectedFolder = that.fileGroups[0].folder;
                        that.selectedGroup = that.fileGroups[0];
                    }
                } else {
                    swal('ERROR', res && res.message ? res.message : 'Failed to load files', 'error');
                }
            })
            .catch(function() {
                that.isLoading = false;
                swal('ERROR', 'Failed to load files', 'error');
            });
    }

    onOpenedFilter(): void {
        this.filterExpand = true;
    }

    onAddFile(event: any): void {
        event.stopPropagation();
        let that = this;
        this.bsModalRef = this.modalService.show(AddDsrFileComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        this.bsModalRef.content.fileAddedEvent.subscribe(() => {
            that.loadFiles();
        });
    }

    onFolderChange(): void {
        this.selectedGroup = this.fileGroups.find(g => g.folder === this.selectedFolder) || null;
    }

    onDownload(file: any): void {
        let that = this;
        this.commonService.downloadDsrInputFile({ relativePath: file.relativePath, name: file.name })
            .then(function(res: any) {
                if (res && res['_body']) {
                    const blob = new Blob([res['_body']], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = file.name;
                    link.click();
                } else {
                    swal('ERROR', 'File not found', 'error');
                }
            })
            .catch(function() {
                swal('ERROR', 'Failed to download file', 'error');
            });
    }

    onReplace(file: any): void {
        this.selectedFile = file;
        this.fileInput.nativeElement.value = '';
        this.fileInput.nativeElement.click();
    }

    onDelete(file: any): void {
        let that = this;
        swal({
            title: 'Delete File?',
            text: 'Are you sure you want to delete "' + file.name + '"? This cannot be undone.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, Delete',
            cancelButtonText: 'Cancel'
        }).then(function() {
            that.commonService.deleteDsrInputFile({ relativePath: file.relativePath })
                .then(function(res: any) {
                    if (res && res.success) {
                        swal('Deleted', res.message || 'File deleted successfully', 'success');
                        that.loadFiles();
                    } else {
                        swal('ERROR', res && res.message ? res.message : 'Failed to delete file', 'error');
                    }
                })
                .catch(function() {
                    swal('ERROR', 'Failed to delete file', 'error');
                });
        }, function() { });
    }

    onFileSelected(event: any): void {
        const uploadFile = event.target.files[0];
        if (!uploadFile || !this.selectedFile) { return; }

        let that = this;
        swal({
            title: 'Replace File?',
            text: 'Replace "' + this.selectedFile.name + '" with "' + uploadFile.name + '"?',
            showCancelButton: true,
            confirmButtonText: 'Yes, Replace',
            cancelButtonText: 'Cancel'
        }).then(function() {
            const formData = new FormData();
            formData.append('file', uploadFile);
            formData.append('relativePath', that.selectedFile.relativePath);
            formData.append('name', that.selectedFile.name);

            that.commonService.uploadReplaceDsrInputFile(formData)
                .then(function(res: any) {
                    if (res && res.success) {
                        swal('SUCCESS', res.message || 'File replaced successfully', 'success');
                        that.loadFiles();
                    } else {
                        swal('ERROR', res && res.message ? res.message : 'Failed to replace file', 'error');
                    }
                })
                .catch(function() {
                    swal('ERROR', 'Failed to replace file', 'error');
                });
        }, function() { });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/dsrInputFiles/dsrInputFiles.component.ts